import * as R from "ramda";
import { errors as lens } from "../lenses";

export default {
  root: R.view(lens)
};
